import type { ReactNode } from 'react'
import { CheckboxGroup } from '@/ui/Field/Field'
import { Stack } from '@/ui/layout/Stack'

/**
 * A `fieldset` of related controls under one legend with an optional help
 * statement (ui/Field's group: the legend in the Field label style, the help
 * linked by `aria-describedby`): the predicate rows, a webhook's rules, a
 * route's behaviour.
 */
export function FieldGroup({
  label,
  help,
  children,
}: {
  label: string
  help?: string
  children: ReactNode
}) {
  return (
    <CheckboxGroup label={label} help={help || undefined}>
      <Stack gap="space-12">{children}</Stack>
    </CheckboxGroup>
  )
}
